export const DOCS = {
  searchInput: "doc-search-input",
  statusFilter: "doc-status-filter",
  directionSelect: "new-doc-direction-select",
  typeSelect: "new-doc-type-select",
  numberInput: "new-doc-number-input",
  dateInput: "new-doc-date-input",
  counterpartyInput: "new-doc-counterparty-input",
  amountInput: "new-doc-amount-input",
  vatInput: "new-doc-vat-input",
  fileInput: "new-doc-file-input",
  saveDraftButton: "save-draft-button",
  createSendButton: "create-send-doc-button",
};
